import { Component, inject } from '@angular/core';
import { ProfileFormComponent } from '../profile-form/profile-form.component';
import { ChangePasswordFormComponent } from '../change-password-form/change-password-form.component';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '@/auth/services/auth.service';
import { NotificationService } from '@/notificaction/notification.service';
import { ConfirmDialogService } from '@edt/util/lib/confirm-dialog/confirm-dialog-service.service';
import { GlobalStore } from '@/store/app.store';
import { Router } from '@angular/router';

@Component({
  selector: 'store-profile-customer',
  imports: [ProfileFormComponent, ChangePasswordFormComponent, MatButtonModule],
  templateUrl: './profile-customer.component.html',
  styleUrl: './profile-customer.component.scss',
  providers: [ConfirmDialogService],
})
export class ProfileCustomerComponent {
  #authService = inject(AuthService);
  #globalStore = inject(GlobalStore);
  #confirmDialogSrv = inject(ConfirmDialogService);
  #notifSrv = inject(NotificationService);
  #router = inject(Router);

  removeCustomer() {
    this.#confirmDialogSrv
      .open({
        cancelText: 'CANCELAR',
        confirmText: 'ELIMINAR',
        message: '¿Desea eliminar su cuenta?',
        title: 'CONFIRMACIÓN',
      })
      .subscribe(result => {
        if (result) {
          this.#authService.removeCustomer().subscribe({
            next: () => {
              this.#notifSrv.showSuccess('Cuenta eliminado correctamente');
              this.#authService.localLogOut();
              this.#globalStore.setAuthUser(null);
              this.#router.navigate(['/']);
            },
            error: () => this.#notifSrv.showError('Ha ocurrido un error'),
          });
        }
      });
  }
}
